'use client';

import { TranslationValues, useTranslations } from 'next-intl';
import { ReactNode } from 'react';

import { TranslationsJsonVariables } from './merged-messages/generated/values';

export type MessageKey = keyof IntlFlattenMessages;

type InferMessage<Key extends MessageKey> = Key extends keyof TranslationsJsonVariables
  ? TranslationsJsonVariables[Key]
  : never;

type Props<T extends MessageKey> = {
  id: T;
} & (InferMessage<T> extends never
  ? {
      values?: never;
    }
  : {
      values: InferMessage<T>;
    });

export const FormattedMessage = <TargetKey extends MessageKey>({ id, values }: Props<TargetKey>): ReactNode => {
  const t = useTranslations();
  return t.rich(id, values as TranslationValues);
};

/**
 * Short alias for {@link FormattedMessage} — same component, same props, just
 * easier to embed in dense JSX (`<T id='...'} />` reads more like inline copy
 * than `<FormattedMessage id='...' />`). Pick whichever fits the surrounding
 * code; new code in dense layouts tends to prefer `T`.
 */
export const T = FormattedMessage;
